import * as React from 'react'
import DateTimeHelper from '../../../Helpers/DateTimeHelper'
import { IEventHistoryItem, getEventStatusText, getTroubleEventStatusClass } from '../../../Model/TroubleEvent'
import { inject } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'

export interface IEventHistoryItemViewProps {
    historyItem: IEventHistoryItem,
    className?: string,
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
export default class EventHistoryItemView extends React.Component<IEventHistoryItemViewProps> {
    render() {
        const { localizationStore, historyItem, className } = this.props
        return (
            <div className={className}>
                <p className="historyChangeDate">
                    {DateTimeHelper.formatDateForList(historyItem.createDate)}
                </p>
                <div className="historyChangeStatus">
                    <p>
                        <span className="userName">{historyItem.userName + ' '}</span>
                        {localizationStore!.t!('changeStatusTo') + ' '}
                    </p>
                    <span
                        className={getTroubleEventStatusClass(historyItem.status)}
                    >
                        {localizationStore!.t(getEventStatusText(historyItem.status))}
                    </span>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/TroubleEvent/EventHistoryItemView.tsx